var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: _vm.$vuetify.breakpoint.smAndDown,
            persistent: "",
            maxWidth: "400"
          },
          model: {
            value: _vm.showAddContactDialog,
            callback: function($$v) {
              _vm.showAddContactDialog = $$v
            },
            expression: "showAddContactDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "title justify-center" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "pr-2", attrs: { color: "accent" } },
                    [_vm._v("person_add_alt_1")]
                  ),
                  _vm._v("Add Dispatch Contact")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "pl-4 pr-4" },
                [
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true },
                        expression: "{ required: true }"
                      }
                    ],
                    attrs: {
                      "prepend-icon": "business",
                      label: "Company Dispatcher Name",
                      placeholder: "Company or Dispatcher Name",
                      "error-messages": _vm.errors.first(
                        "dispatcherName",
                        "contact"
                      ),
                      "data-vv-as": "Company Dispatcher Name",
                      "data-vv-name": "dispatcherName",
                      "data-vv-scope": "contact"
                    },
                    model: {
                      value: _vm.addContactName,
                      callback: function($$v) {
                        _vm.addContactName = $$v
                      },
                      expression: "addContactName"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true },
                        expression: "{ required: true }"
                      }
                    ],
                    staticClass: "mt-2",
                    attrs: {
                      "prepend-icon": "phonelink_ring",
                      label: "Phone Number to send SMS text messages",
                      placeholder: "Dispatcher Phone Number",
                      "error-messages": _vm.errors.first(
                        "dispatcherPhone",
                        "contact"
                      ),
                      "data-vv-as": "Company Dispatcher Phone",
                      "data-vv-name": "dispatcherPhone",
                      "data-vv-scope": "contact"
                    },
                    model: {
                      value: _vm.addContactPhone,
                      callback: function($$v) {
                        _vm.addContactPhone = $$v
                      },
                      expression: "addContactPhone"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "accent",
                        disabled: _vm.errors.any("contact")
                      },
                      on: {
                        click: function($event) {
                          return _vm.addContact()
                        }
                      }
                    },
                    [_vm._v("Add")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.cancelAddContact()
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "pa-0 ma-0", attrs: { fluid: "" } },
        [
          _c(
            "v-card",
            {
              staticClass: "full-card-desktop py-0 px-0",
              attrs: { expand: "", flat: "" }
            },
            [
              _c(
                "v-alert",
                { attrs: { value: !_vm.hasProducerInfo, type: "warning" } },
                [
                  _vm._v(
                    "\n      This company is not set up as a " +
                      _vm._s(
                        _vm.$t("booked-load.producer").toLocaleLowerCase()
                      ) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "v-toolbar",
                {
                  staticClass: "darken-1",
                  attrs: { dense: "", flat: "", color: "white" }
                },
                [
                  _c("v-toolbar-title", [_vm._v("Outside Dispatching")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-tabs",
                        {
                          attrs: { color: "darken-2", grow: "" },
                          model: {
                            value: _vm.currentTab,
                            callback: function($$v) {
                              _vm.currentTab = $$v
                            },
                            expression: "currentTab"
                          }
                        },
                        [
                          _c(
                            "v-tab",
                            { key: "network", attrs: { value: "chicken" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { column: "" } },
                                [
                                  _c("v-icon", { attrs: { color: "accent" } }, [
                                    _vm._v("hub")
                                  ]),
                                  _vm._v(
                                    "\n              LTN Network\n            "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            { key: "contacts", attrs: { value: "waffles" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { column: "" } },
                                [
                                  _c("v-icon", { attrs: { color: "accent" } }, [
                                    _vm._v("headset_mic")
                                  ]),
                                  _vm._v(
                                    "\n              Contacts\n            "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.networkTabSelected && _vm.hasDispatchPerm
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "accent",
                                    disabled: !_vm.selected || _vm.loading
                                  },
                                  on: { click: _vm.sendInvite }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { column: "" } },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "white" } },
                                        [_vm._v("share")]
                                      ),
                                      _vm._v(
                                        "\n              Invite\n            "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.contactTabSelected && _vm.hasDispatchPerm
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { color: "accent" },
                                  on: {
                                    click: function($event) {
                                      _vm.showAddContactDialog = true
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { column: "" } },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "white" } },
                                        [_vm._v("person_add_alt_1")]
                                      ),
                                      _vm._v(
                                        "\n              Add Contact\n            "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tabs-items",
                {
                  model: {
                    value: _vm.currentTab,
                    callback: function($$v) {
                      _vm.currentTab = $$v
                    },
                    expression: "currentTab"
                  }
                },
                [
                  _c(
                    "v-tab-item",
                    { key: "network" },
                    [
                      _c("v-card-title", [
                        _vm._v("Your Preferred Carrier Network of LTN Accounts")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          staticClass: "mr-1 mt-4",
                          attrs: {
                            column: _vm.$vuetify.breakpoint.smAndDown,
                            "align-baseline": ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            [
                              _c("v-autocomplete", {
                                staticClass: "mr-3",
                                attrs: {
                                  loading: _vm.loading && !!_vm.search,
                                  items:
                                    _vm.search && _vm.search.length > 3
                                      ? _vm.allTruckingCompanies
                                      : [],
                                  "search-input": _vm.search,
                                  clearable: "",
                                  "item-text": "searchName",
                                  "return-object": "",
                                  "hide-no-data": "",
                                  disabled: !_vm.hasDispatchPerm,
                                  "hide-details": "",
                                  label: "Search LTN Accounts to Add"
                                },
                                on: {
                                  "update:searchInput": function($event) {
                                    _vm.search = $event
                                  },
                                  "update:search-input": function($event) {
                                    _vm.search = $event
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item",
                                    fn: function(data) {
                                      return [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              color: _vm._.get(
                                                data,
                                                "item.accountStatus.verified",
                                                null
                                              )
                                                ? "green"
                                                : "transparent"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  verified_user\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "ml-1" }, [
                                          _vm._v(_vm._s(data.item.searchName))
                                        ])
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.selected,
                                  callback: function($$v) {
                                    _vm.selected = $$v
                                  },
                                  expression: "selected"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            [
                              _vm.hideInactive
                                ? [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "mr-4",
                                        attrs: {
                                          block:
                                            _vm.$vuetify.breakpoint.smAndDown,
                                          flat: "",
                                          color: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.hideInactive = false
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", { staticClass: "mr-2" }, [
                                          _vm._v("visibility")
                                        ]),
                                        _vm._v(
                                          "\n                Show inactive\n              "
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                : [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "mr-4",
                                        attrs: {
                                          block:
                                            _vm.$vuetify.breakpoint.smAndDown,
                                          flat: "",
                                          color: "accent"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.hideInactive = true
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", { staticClass: "mr-2" }, [
                                          _vm._v("visibility_off")
                                        ]),
                                        _vm._v(
                                          "\n                Hide inactive\n              "
                                        )
                                      ],
                                      1
                                    )
                                  ]
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.members.length
                        ? [
                            _vm.$vuetify.breakpoint.smAndDown
                              ? _vm._l(_vm.members, function(member) {
                                  return _c(
                                    "v-card",
                                    {
                                      key: member.id,
                                      staticClass: "xs12 my-2"
                                    },
                                    [
                                      _c(
                                        "v-card-title",
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { column: "" } },
                                            [
                                              _c(
                                                "h6",
                                                { staticClass: "title" },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        member.companyName
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-text",
                                        [
                                          _c("b", [_vm._v("Member since:")]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("formatDate")(
                                                  member.memberSince
                                                )
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("b", [_vm._v("Verified since:")]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("formatDate")(
                                                  member.verifiedSince
                                                )
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "accent",
                                                    block: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.removeMember(
                                                        member.companyId
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Remove\n                  "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                })
                              : _c("v-data-table", {
                                  attrs: {
                                    headers: _vm.membersHeaders,
                                    pagination: _vm.pagination,
                                    "hide-actions": "",
                                    "disable-initial-sort": "",
                                    items: _vm.members
                                  },
                                  on: {
                                    "update:pagination": function($event) {
                                      _vm.pagination = $event
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "items",
                                        fn: function(slotItems) {
                                          return [
                                            _c("tr", [
                                              _c("td", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      slotItems.item.companyName
                                                    ) +
                                                    "\n                "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm._f("formatDate")(
                                                        slotItems.item
                                                          .memberSince
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm._f("formatDate")(
                                                        slotItems.item
                                                          .verifiedSince
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        flat: "",
                                                        small: "",
                                                        color: "accent"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.removeMember(
                                                            slotItems.item
                                                              .companyId
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    Remove\n                  "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3193162752
                                  )
                                })
                          ]
                        : _c("div", [
                            _vm._v(
                              "You have no Carriers in your Dispatching Network."
                            )
                          ]),
                      _vm._v(" "),
                      _c("v-layout", { attrs: { "align-baseline": "" } }, [
                        _c("div", { staticClass: "title mr-3 mt-4" }, [
                          _vm._v(
                            "\n            Received Invitations\n          "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.received.length
                        ? [
                            _vm.$vuetify.breakpoint.smAndDown
                              ? _vm._l(_vm.received, function(receivedItem) {
                                  return !_vm.requestInvitationId ||
                                    receivedItem.id === _vm.requestInvitationId
                                    ? _c(
                                        "v-card",
                                        {
                                          key: receivedItem.id,
                                          staticClass: "xs12 my-2"
                                        },
                                        [
                                          _c(
                                            "v-card-title",
                                            [
                                              _c(
                                                "v-layout",
                                                { attrs: { column: "" } },
                                                [
                                                  _c(
                                                    "h6",
                                                    { staticClass: "title" },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            receivedItem.host
                                                              .companyName
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card-text",
                                            [
                                              _c("b", [_vm._v("Invited by:")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    receivedItem.invitedByDisplayName
                                                  )
                                              ),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("b", [_vm._v("Status:")]),
                                              _vm._v(" "),
                                              receivedItem.status === "OFFERED"
                                                ? _c(
                                                    "v-chip",
                                                    {
                                                      attrs: {
                                                        color: "success",
                                                        "text-color": "white"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            receivedItem.status
                                                          ) +
                                                          "\n                "
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "v-chip",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        "text-color": "white"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            receivedItem.status
                                                          ) +
                                                          "\n                "
                                                      )
                                                    ]
                                                  ),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                [
                                                  receivedItem.status ===
                                                  "OFFERED"
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            color: "primary",
                                                            block: "",
                                                            disabled: !_vm.hasDispatchPerm
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.acceptCDN(
                                                                receivedItem.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    Accept\n                  "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  receivedItem.status ===
                                                  "OFFERED"
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            flat: "",
                                                            small: "",
                                                            color: "accent",
                                                            block: "",
                                                            disabled: !_vm.hasDispatchPerm
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removeCDN(
                                                                receivedItem.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    Refuse\n                  "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                })
                              : _c("v-data-table", {
                                  attrs: {
                                    headers: _vm.headers,
                                    pagination: _vm.pagination,
                                    "disable-initial-sort": "",
                                    "hide-actions": "",
                                    items: _vm.received
                                  },
                                  on: {
                                    "update:pagination": function($event) {
                                      _vm.pagination = $event
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "items",
                                        fn: function(slotItems) {
                                          return [
                                            _c(
                                              "tr",
                                              {
                                                class: {
                                                  "selected-invitation":
                                                    slotItems.item.id ===
                                                    _vm.requestInvitationId
                                                },
                                                attrs: {
                                                  bgcolor:
                                                    slotItems.item.id ===
                                                    _vm.requestInvitationId
                                                      ? "#88a2aa"
                                                      : null
                                                }
                                              },
                                              [
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        slotItems.item.host
                                                          .companyName
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        slotItems.item
                                                          .invitedByDisplayName
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  [
                                                    slotItems.item.status ===
                                                    "OFFERED"
                                                      ? _c(
                                                          "v-chip",
                                                          {
                                                            attrs: {
                                                              color: "success",
                                                              "text-color":
                                                                "white"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  slotItems.item
                                                                    .status
                                                                ) +
                                                                "\n                  "
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "v-chip",
                                                          {
                                                            attrs: {
                                                              color: "primary",
                                                              "text-color":
                                                                "white"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  slotItems.item
                                                                    .status
                                                                ) +
                                                                "\n                  "
                                                            )
                                                          ]
                                                        )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  [
                                                    slotItems.item.status ===
                                                    "OFFERED"
                                                      ? _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              small: "",
                                                              color:
                                                                slotItems.item
                                                                  .id ===
                                                                _vm.requestInvitationId
                                                                  ? "accent"
                                                                  : "primary",
                                                              disabled: !_vm.hasDispatchPerm
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.acceptCDN(
                                                                  slotItems.item
                                                                    .id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    Accept\n                  "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    slotItems.item.status ===
                                                    "OFFERED"
                                                      ? _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              flat: "",
                                                              small: "",
                                                              color: "accent",
                                                              disabled: !_vm.hasDispatchPerm
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.removeCDN(
                                                                  slotItems.item
                                                                    .id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    Refuse\n                  "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3497952144
                                  )
                                })
                          ]
                        : _c("div", [
                            _vm._v(
                              "No invitations received to join other CDNs at this time."
                            )
                          ]),
                      _vm._v(" "),
                      _c("v-layout", { attrs: { "align-baseline": "" } }, [
                        _c("div", { staticClass: "title mr-3 mt-4" }, [
                          _vm._v(
                            "\n            Offered Invitations\n          "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.offered.length
                        ? [
                            _vm.$vuetify.breakpoint.smAndDown
                              ? _vm._l(_vm.offered, function(offeredItem) {
                                  return _c(
                                    "v-card",
                                    {
                                      key: offeredItem.id,
                                      staticClass: "xs12 my-2"
                                    },
                                    [
                                      _c(
                                        "v-card-title",
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { column: "" } },
                                            [
                                              _c(
                                                "h6",
                                                { staticClass: "title" },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        offeredItem.invited
                                                          .companyName
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-text",
                                        [
                                          _c("b", [_vm._v("Invited by:")]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                offeredItem.invitedByDisplayName
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("b", [_vm._v("Status:")]),
                                          _vm._v(" "),
                                          offeredItem.status === "OFFERED"
                                            ? _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    color: "success",
                                                    "text-color": "white"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        offeredItem.status
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    color: "primary",
                                                    "text-color": "white"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        offeredItem.status
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              offeredItem.status === "OFFERED"
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "accent",
                                                        block: "",
                                                        disabled: !_vm.hasDispatchPerm
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.removeCDN(
                                                            offeredItem.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    Remove\n                  "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                })
                              : _c("v-data-table", {
                                  attrs: {
                                    headers: _vm.headers,
                                    pagination: _vm.pagination,
                                    "hide-actions": "",
                                    "disable-initial-sort": "",
                                    items: _vm.offered
                                  },
                                  on: {
                                    "update:pagination": function($event) {
                                      _vm.pagination = $event
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "items",
                                        fn: function(slotItems) {
                                          return [
                                            _c("tr", [
                                              _c("td", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      slotItems.item.invited
                                                        .companyName
                                                    ) +
                                                    "\n                "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      slotItems.item
                                                        .invitedByDisplayName
                                                    ) +
                                                    "\n                "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                [
                                                  slotItems.item.status ===
                                                  "OFFERED"
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          attrs: {
                                                            color: "success",
                                                            "text-color":
                                                              "white"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                slotItems.item
                                                                  .status
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "v-chip",
                                                        {
                                                          attrs: {
                                                            color: "primary",
                                                            "text-color":
                                                              "white"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                slotItems.item
                                                                  .status
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ]
                                                      )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                [
                                                  slotItems.item.status ===
                                                  "OFFERED"
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            color: "accent",
                                                            flat: "",
                                                            disabled: !_vm.hasDispatchPerm
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removeCDN(
                                                                slotItems.item
                                                                  .id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    Remove\n                  "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2640548860
                                  )
                                })
                          ]
                        : _c("div", [
                            _vm._v(
                              "No invitations to join your CDN at this time."
                            )
                          ])
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab-item",
                    { key: "contacts" },
                    [
                      _c("v-card-title", [_vm._v("Partner Dispatchers")]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs6: "" } },
                        [
                          _c(
                            "v-list",
                            _vm._l(_vm.company.dispatchContacts, function(
                              contact
                            ) {
                              return _c(
                                "v-list-tile",
                                {
                                  key: "companyDispatchContacts-" + contact.id
                                },
                                [
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "accent" } },
                                        [_vm._v("headset_mic")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(_vm._s(contact.name))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-sub-title",
                                        { staticClass: "font-italic" },
                                        [_vm._v(_vm._s(contact.phone))]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-avatar",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            flat: "",
                                            fab: "",
                                            small: "",
                                            color: "accent"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeDispatchContact(
                                                contact
                                              )
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("cancel")])],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5280630", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5280630","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Sections/DispatchingInfoSection.vue
// module id = null
// module chunks = 